import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const ClearButton = ({
    clickHandler,
}) => (
    <Button onClick={clickHandler} bsSize="large" bsStyle="primary">
    <span className="form-searchBtn-text">&nbsp; Clear Form</span>
    </Button>
);

ClearButton.propTypes = {
    clickHandler: PropTypes.func,
};

export default ClearButton;



// WEBPACK FOOTER //
// ./src/components/searchForm/components/searchFormButtons/components/clearButton.js